module.exports = __webpack_public_path__ + "static/media/social-share.de4bef6b.jpg";